import { aboutInfo } from '@/mocks/homepage';

export default function About() {
  return (
    <section id="about" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="flex-1">
            <h2 className="text-xl md:text-3xl font-bold text-foreground-900 font-heading mb-5">
              {aboutInfo.title}
            </h2>
            {aboutInfo.paragraphs.map((p, idx) => (
              <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                {p}
              </p>
            ))}
          </div>

          <div className="flex-1 w-full">
            <div className="grid grid-cols-2 gap-4">
              {aboutInfo.stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-100 rounded-xl p-5 md:p-6 text-center border border-background-200/50"
                >
                  <div className="text-2xl md:text-3xl font-extrabold text-primary-500 font-heading mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 font-medium">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-5 bg-accent-100/70 rounded-xl p-5 border border-accent-200/50">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center shrink-0">
                  <i className="ri-shield-star-line text-background-50 text-lg"></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-accent-900">正版内容 · 安全观影</p>
                  <p className="text-xs text-accent-700">所有内容均获得合法授权，严格审核确保内容健康合规</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}